"use strict";

import angular from "angular";

angular.module("nucont.accounting.nps", ["nucont.shared"]);
require("./nps.routes");
